export default __webpack_public_path__ + "static/media/metaz.f3ded33f.svg";